<div class="asset-mapping-sub" cdkDropListGroup>
  <div class="column pool-column">
    <h4 data-testid="discard-heading">Discard ({{ poolSources.length }} to delete)</h4>
    <div
      cdkDropList
      data-testid="pool-drop-list"
      [cdkDropListData]="poolSources"
      (cdkDropListDropped)="onDrop($event)"
      class="drop-zone"
    >
      @for (source of poolSources; track source.id) {
        <div cdkDrag [cdkDragData]="source" class="asset-card" data-testid="pool-asset-card">
          <div class="asset-card-header">
            <mat-icon class="drag-handle" data-testid="asset-drag-handle">drag_indicator</mat-icon>
            <span class="asset-card-label">
              @if (isSourceEnhancementFlagged(source)) {
                <mat-icon class="enhancement-sparkle enhancement-sparkle-source" data-testid="enhancement-sparkle">auto_awesome</mat-icon>
              }
              {{ assetLabel(source) }}
            </span>
            <button
              type="button"
              class="asset-expand-btn"
              data-testid="asset-expand-btn"
              (click)="toggleExpanded(source); $event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
            >
              <mat-icon>{{ isExpanded(source) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </div>
          @if (isExpanded(source)) {
            <div class="asset-detail" data-testid="asset-detail">
              <div>Type: {{ source.packageAssetType }}</div>
              <div>Robot: {{ source.packageAssetRobotOutDegrees }}°</div>
              <div>Table: {{ source.packageAssetTablePosition }}</div>
              <div>Index: {{ source.packageAssetIndex }}</div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="column destination-column">
    <h4>Destinations</h4>
    @for (destinationAsset of destinationAssets; track destinationAsset.id) {
      <div class="destination-slot" data-testid="destination-slot">
        <div class="slot-label">
          @if (isDestinationEnhancementFlagged(destinationAsset)) {
            <mat-icon class="enhancement-sparkle enhancement-sparkle-destination" data-testid="enhancement-sparkle">auto_awesome</mat-icon>
          }
          {{ assetLabel(destinationAsset) }}
        </div>
        <div
          cdkDropList
          [cdkDropListData]="slotFor(destinationAsset.id!)"
          [cdkDropListEnterPredicate]="canEnterSlot"
          (cdkDropListDropped)="onDrop($event)"
          class="drop-zone slot"
        >
          @for (source of slotFor(destinationAsset.id!); track source.id) {
            <div cdkDrag [cdkDragData]="source" class="asset-card mapped" data-testid="slot-asset-card">
              <div class="asset-card-header">
                <mat-icon class="drag-handle" data-testid="asset-drag-handle">drag_indicator</mat-icon>
                <span class="asset-card-label">
                  @if (isSourceEnhancementFlagged(source)) {
                    <mat-icon class="enhancement-sparkle enhancement-sparkle-source" data-testid="enhancement-sparkle">auto_awesome</mat-icon>
                  }
                  {{ assetLabel(source) }}
                </span>
                <button
                  type="button"
                  class="asset-expand-btn"
                  data-testid="asset-expand-btn"
                  (click)="toggleExpanded(source); $event.stopPropagation()"
                  (mousedown)="$event.stopPropagation()"
                >
                  <mat-icon>{{ isExpanded(source) ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </div>
              @if (isExpanded(source)) {
                <div class="asset-detail" data-testid="asset-detail">
                  <div>Type: {{ source.packageAssetType }}</div>
                  <div>Robot: {{ source.packageAssetRobotOutDegrees }}°</div>
                  <div>Table: {{ source.packageAssetTablePosition }}</div>
                  <div>Index: {{ source.packageAssetIndex }}</div>
                  <div>Package Asset ID: {{ source.packageAssetId }}</div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
